import { Banner } from "../api/misc.types";
import { PROCESSING_PROGRAM, MISC_UPDATE, LOADING_TRIAL_PERIOD, LOADING_BANNER, BANNER_UPDATE } from "../actions/types";

export interface MiscState {
    loadingTrialPeriod?: boolean;
    trialPeriod?: number;
    processingProgram: boolean;
    loadingBanner?: boolean;
    homeBanner?: Banner;
}

const InitialState: MiscState = {
    loadingTrialPeriod: false,
    processingProgram: false,
    loadingBanner: false,
    homeBanner: {
        imageUrl: '',
        linkUrl: '',
        title: '',
        enabled: false,
    },
};

export const MiscReducer = (state: MiscState = InitialState, action: any) => {
    switch (action.type) {
        case LOADING_TRIAL_PERIOD:
            return {
                ...state,
                loadingTrialPeriod: action.payload,
            };
        case MISC_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
        case PROCESSING_PROGRAM:
            return {
                ...state,
                processingProgram: action.payload,
            };
        case  LOADING_BANNER:
            return {
                ...state,
                loadingBanner: action.payload,
            };
        case BANNER_UPDATE:
            return {
                ...state,
                homeBanner: action.payload,
            };
        default:
            break;
    }
    return state;
}

export default MiscReducer;